// extracted by mini-css-extract-plugin
export default {"eventsGrid":"Reports_eventsGrid__pUPp+","tableHeader":"Reports_tableHeader__ChgXE"};